import styled from 'styled-components'

import { helpers } from 'styles'

export const Container = styled.nav`
	font-size: 14px;
	padding: 24px 0;
	flex-shrink: 0;
	position: sticky;
	top: 0;
	height: calc(100vh - 61px);
	border-right: 1px solid ${helpers.color.border};
	background-color: ${helpers.color.background};
	width: 280px;
	overflow-y: auto;

	@media only screen and (max-width: 750px) {
		z-index: 99;
		position: absolute;
		top: 61px;
		bottom: 0;
		height: unset;
		transition: left 135ms ease;
	}
`
